import React from "react";
import "./Footer.css"



export default function Footer(){

    return (
        <div className="footer">
           <p><a
        href="https://github.com/Asofiamartins/dictionary-project"
        target="_blank"
        rel="noreferrer"
      >
        Open-source code{" "}
      </a>
      by
      <a href="http://www.linkedin.com/in/asofia-martins" target="_blank" rel="noreferrer">
        {" "}
        Sofia Martins
      </a></p>
        </div>
    )
}